/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through integration tests (E2E) */

/**
 * The entry point for the admin side wp-admin resource.
 */
import "@wpnotes/utils"; // Import once for startup polyfilling (e. g. setimmediate)
import { render } from "react-dom";
import { DashboardComponent } from "./components";
import { RootStore } from "./store";
import React from "react";
import { MetboxComponent } from "./components";
import "./style/admin.scss";

const dashboardNode = document.getElementById(`bdotstd-dashboard-list-component`);
const postListNote = document.getElementById(`bdotstd-metabox-component`);

if (dashboardNode) {
    render(
        <RootStore.StoreProvider>
            <DashboardComponent />
        </RootStore.StoreProvider>,
        dashboardNode
    );
}

if (postListNote) {
    render(
        <RootStore.StoreProvider>
            <MetboxComponent />
        </RootStore.StoreProvider>,
        postListNote
    );
}

// Expose this functionalities to add-ons, but you need to activate the library functionality
// in your webpack configuration, see also https://webpack.js.org/guides/author-libraries/
export * from "@wpnotes/utils";
export * from "./wp-api";
export * from "./store";
